import { render, staticRenderFns } from "./PreIngreso.vue?vue&type=template&id=199aac03"
import script from "./PreIngreso.vue?vue&type=script&lang=js"
export * from "./PreIngreso.vue?vue&type=script&lang=js"
import style0 from "./PreIngreso.vue?vue&type=style&index=0&id=199aac03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports